import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("TAMARAC_TRANSACTIONS");
const CRUD_ACTION_HANDLERS = getActionHandler("TAMARAC_TRANSACTIONS");

export default function tamaracTransactions(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
